var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaySvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5250f2"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M107.28,179.408c9.424-1.616,22.672-2.816,41.328-2.816c18.88,0,32.32,3.616,41.344,10.848 c8.64,6.816,14.448,18.064,14.448,31.296c0,13.248-4.416,24.48-12.432,32.112c-10.432,9.84-25.888,14.256-43.952,14.256 c-4.016,0-7.632-0.208-10.432-0.592v48.352H107.28V179.408z M137.584,240.816c2.608,0.608,5.824,0.8,10.24,0.8 c16.256,0,26.304-8.224,26.304-22.064c0-12.448-8.64-19.872-23.888-19.872c-6.224,0-10.432,0.608-12.64,1.2v39.936H137.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M274.992,312.864l-1.808-9.824h-0.592c-6.416,7.824-16.448,12.032-28.096,12.032 c-19.872,0-31.712-14.432-31.712-30.096c0-25.488,22.896-37.728,57.616-37.536v-1.408c0-5.216-2.816-12.64-17.856-12.64 c-10.048,0-20.672,3.408-27.088,7.424l-5.632-19.664c6.832-3.808,20.272-8.624,38.128-8.624c32.72,0,43.152,19.264,43.152,42.336 v34.128c0,9.424,0.384,18.448,1.408,23.872H274.992z M271.376,266.496c-16.064-0.208-28.496,3.616-28.496,15.456 c0,7.824,5.216,11.648,12.048,11.648c7.632,0,13.84-5.008,15.84-11.232c0.4-1.616,0.608-3.424,0.608-5.216V266.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M345.584,214.72l14.64,48.176c1.616,5.808,3.616,13.04,4.832,18.272h0.592 c1.408-5.216,3.008-12.64,4.416-18.272l12.032-48.176h32.72l-22.88,64.624c-14.048,38.944-23.488,54.592-34.528,64.416 c-10.624,9.232-21.872,12.432-29.504,13.44l-6.416-25.872c3.808-0.608,8.64-2.416,13.248-5.216c4.624-2.4,9.648-7.232,12.64-12.256 c0.992-1.408,1.616-3.008,1.616-4.4c0-1.008-0.208-2.608-1.408-5.008l-35.92-89.712h33.92V214.72z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaySvgrepoCom);
export default __webpack_public_path__ + "static/media/pay-svgrepo-com.d52f3db586626b5ec11e61868b44e823.svg";
export { ForwardRef as ReactComponent };